import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate, Link } from 'react-router-dom';
import Products2Hero from '../components/Products2Hero';
import RefurbishedVsNewArticle from '../components/blog/articles/RefurbishedVsNewArticle';
import WFHSetupArticle from '../components/blog/articles/WFHSetupArticle';
import I3vsI5vsI7Article from '../components/blog/articles/I3vsI5vsI7Article';
import Top7BenefitsArticle from '../components/blog/articles/Top7BenefitsArticle';
import Checklist10Article from '../components/blog/articles/Checklist10Article';
import MaintenanceArticle from '../components/blog/articles/MaintenanceArticle';
import GamingLaptopsUnder50kArticle from '../components/blog/articles/GamingLaptopsUnder50kArticle';
import BLOG_ARTICLES from '../data/blogArticles';
import './BlogPage.css';

/* ─── Article slug → component map ─── */
const ARTICLE_MAP = {
  'refurbished-vs-new': RefurbishedVsNewArticle,
  'wfh-setup-guide': WFHSetupArticle,
  'i3-vs-i5-vs-i7': I3vsI5vsI7Article,
  'top-7-benefits-refurbished-laptops-india': Top7BenefitsArticle,
  '10-essential-checks-buying-second-hand-laptop': Checklist10Article,
  'laptop-maintenance-simple-habits-for-longevity': MaintenanceArticle,
  'best-gaming-laptops-under-50000': GamingLaptopsUnder50kArticle,
};

/* BLOG_ARTICLES imported from src/data/blogArticles.js */

/* ─── Blog Listing Component ─── */
const BlogListing = () => {
  const navigate = useNavigate();

  return (
    <div className="blog-listing">
      <div className="blog-listing-header">
        <span className="blog-listing-label">
          <span className="blog-label-dot" />
          Latest Articles
        </span>
        <h2 className="blog-listing-title">Tech Insights & Buying Guides</h2>
        <p className="blog-listing-subtitle">Expert advice to help you make smarter technology decisions.</p>
      </div>

      <div className="blog-grid">
        {BLOG_ARTICLES.map((article) => (
          <Link
            to={`/blog/${article.slug}`}
            key={article.slug}
            className="blog-card"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div className="blog-card-image">
              <img src={article.image} alt={article.title} loading="lazy" />
              <div className="blog-card-overlay">
                <span className="blog-card-read">Read Article →</span>
              </div>
            </div>
            <div className="blog-card-body">
              <div className="blog-card-tags">
                {article.tags.map((tag) => (
                  <span key={tag} className="blog-card-tag">#{tag}</span>
                ))}
              </div>
              <h3 className="blog-card-title">{article.title}</h3>
              <p className="blog-card-excerpt">{article.excerpt}</p>
              <div className="blog-card-meta">
                <div className="blog-card-author-avatar">{article.authorEmoji}</div>
                <div>
                  <div className="blog-card-author">{article.author}</div>
                  <div className="blog-card-date">{article.date} · {article.readTime}</div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

const BlogPage = () => {
  const { slug } = useParams();

  /* If a slug matches an article, render it directly */
  const ArticleComponent = slug ? ARTICLE_MAP[slug] : null;
  if (ArticleComponent) {
    return <ArticleComponent />;
  }

  /* Otherwise show the blog index */
  return (
    <div className="blog-page">
      <Helmet>
        <title>Blog | Nexawave</title>
        <meta name="description" content="Expert tech insights, laptop buying guides, and technology reviews from Nexawave." />
        <link rel="canonical" href="https://nexawave.com/blog" />
      </Helmet>

      <Products2Hero 
        className="hero-tight"
        tagline="LATEST NEWS · TECH REVIEWS · PERFORMANCE GUIDES"
        title1="Blog"
        title2=""
        title3=""
        description=""
        button1Text=""
        button1Link=""
      />
      <BlogListing />
    </div>
  );
};

export default BlogPage;